import Main from '@/components/main';
import CategoryManagement from './category-management';
import SerialManagement from './serial-management';
import BrandManagement from './brand-management';
import ProductManagement from './product-management';
import ProductApprove from './productApprove-management';

export default {
    path: '/product-management',
    name: 'product-management',
    meta: {
        icon: 'ios-cube',
        title: '信息管理',
        showAlways: true
    },
    component: Main,
    children: [
        {
            path: 'info-product-list',
            name: 'info-product-list',
            meta: {
                icon: 'md-cube',
                title: '商品列表',
                notCache: true,
                access: ['D', 'I', 'A', 'G', 'H', 'S', 'J', 'P'],
                items: [
                ]
            },
            component: () => import('@/view/info-management/info-product-list')
        },
        // {
        //     path: 'info-standardcard-list',
        //     name: 'info-standardcard-list',
        //     meta: {
        //         icon: 'md-cube',
        //         title: '标准卡列表',
        //         notCache: true,
        //         access: ['B', 'C', 'D', 'S', 'G', 'H'],
        //         items: [
        //         ]
        //     },
        //     component: () => import('@/view/info-management/info-standardcard-list')
        // },
        {
            path: 'info-member-list',
            name: 'info-member-list',
            meta: {
                icon: 'md-cube',
                title: '会员列表',
                notCache: true,
                access: ['B', 'D', 'I', 'S', 'G', 'A', 'P', 'J'],
                items: [
                ]
            },
            component: () => import('@/view/info-management/info-member-list')
        },
        {
            path: 'customer-manager-list',
            name: 'customer-manager-list',
            meta: {
                icon: 'md-cube',
                title: '客户经理列表',
                notCache: true,
                access: ['B', 'D', 'I', 'S', 'G', 'A', 'P', 'R'],
                items: [
                ]
            },
            component: () => import('@/view/info-management/info-customer-manager-list')
        },
		
        {
            path: 'seedFarm-management-list',
            name: 'seedFarm-management-list',
            meta: {
                icon: 'md-cube',
                title: '苗场列表',
                notCache: true,
                access: ['D', 'I', 'S', 'H', 'G', 'A', 'P', 'B', 'R'],
                items: [
                ]
            },
            component: () => import('@/view/seedFarm-management/seedFarm-list/seedFarm-list')
        },
        // {
        //     path: 'seedFarm-OfficialAccountArticle-list',
        //     name: 'seedFarm-OfficialAccountArticle-list',
        //     meta: {
        //         icon: 'md-cube',
        //         title: '苗场公众号文章列表',
        //         notCache: true,
        //         access: ['S','B'],
        //         items: [
        //         ]
        //     },
        //     component: () => import('@/view/seedFarm-management/seedFarm-OfficialAccountArticle-list/seedFarm-OfficialAccountArticle-list')
        // },
        ...CategoryManagement,
        ...SerialManagement,
        ...BrandManagement,
        ...ProductManagement,
        ...ProductApprove,
        {
            path: 'distributionStation-management-list',
            name: 'distributionStation-management-list',
            meta: {
                icon: 'md-cube',
                title: '转运站列表',
                notCache: true,
                access: ['B', 'I', 'S', 'G', 'A', 'D', 'P', 'R'],
                items: [
                ]
            },
            component: () => import('@/view/distributionStation-management/distributionStation-list/distributionStation-list')
        },
        {
            path: 'info-preSalePlan-list',
            name: 'info-preSalePlan-list',
            meta: {
                icon: 'md-cube',
                title: '供货计划',
                notCache: true,
                access: [ 'A', 'G', 'S', 'J', 'P'],
                items: [
                ]
            },
            component: () => import('@/view/info-management/info-preSalePlan-list')
        },
        // {
        //     path: 'info-preSalePlan-list-V2',
        //     name: 'info-preSalePlan-list-V2',
        //     meta: {
        //         icon: 'md-cube',
        //         title: '供货计划V2',
        //         notCache: true,
        //         access: [ 'A', 'G', 'S','J','P'],
        //         items: [
        //         ]
        //     },
        //     component: () => import('@/view/preSale-management/preSale-plan/preSale-planV2')
        // },
        {
		    path: 'box-management',
		    name: 'box-management',
		    meta: {
		        icon: 'md-cube',
		        title: '纸箱型号',
		        notCache: true,
		        access: ['S'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/product-management/box-management')
        },
        {
		    path: 'relationship-list',
		    name: 'relationship-list',
		    meta: {
		        icon: 'md-cube',
		        title: '认可关系列表',
		        notCache: true,
		        access: ['G'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/info-management/relationship-list')
        },
        {
            path: 'seedFarm-member-black-list',
            name: 'seedFarm-member-black-list',
            meta: {
                icon: 'md-cube',
                title: '黑名单列表',
                notCache: false,
                access: ['B', 'G', 'S', 'J'],
                items: [
                ]
            },
            component: () => import('@/view/seedFarm-management/seedFarm-member-black-list/seedFarm-member-black-list')
        }
    ]
};
